import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicPartnersUniversities({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 80 80"
      fill="none"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g clipPath="url(#pic-partners-universities_svg__a)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40.65 4.14a4 4 0 00-2.104 0L5.158 13.248c-6.877 1.875-6.877 11.63 0 13.506l1.44.393v37.657a6 6 0 106 0v-36.02l4.002 1.09a4.064 4.064 0 00-.002.127v22.953c0 2.863 1.761 5.518 4.554 6.531 6.306 2.29 12.006 3.46 17.957 3.434 5.924-.026 11.877-1.236 18.68-3.433 2.907-.938 4.81-3.647 4.81-6.628V30l-.003-.126 11.442-3.12c6.878-1.876 6.878-11.632 0-13.507L40.651 4.14zm13.948 27.915L40.651 35.86a4 4 0 01-2.105 0l-13.948-3.804V52.22c5.328 1.869 9.88 2.718 14.476 2.698 4.639-.02 9.527-.926 15.524-2.812v-20.05zm-15-4.201L10.801 20l28.797-7.854L68.396 20l-28.798 7.854z"
          fill="#F4F5FB"
        />
      </g>
      <defs>
        <clipPath id="pic-partners-universities_svg__a">
          <path fill="#fff" d="M0 0h80v80H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

SvgPicPartnersUniversities.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicPartnersUniversities.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicPartnersUniversities svgRef={ref} {...props} />
));
export default ForwardRef;
